// extracted by mini-css-extract-plugin
export default {"head_title":"index_head_title_qeikH","sub_title":"index_sub_title_tGfKc","title":"index_title_giAoG"};